export default "__VITE_ASSET__BPmPn_0J__"